import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { buildImageSrcSet, generateImageSources, getImageDimensions, isSvgImage } from './Picture.helpers';
import styles from './Picture.module.scss';
export const Picture = ({ asset, description, isBackground, isFullWidth, loading = 'lazy', maxWidth = 1024, params, ...props })=>{
    if (!asset?.filename) {
        return null;
    }
    const [width, height] = getImageDimensions(asset.filename) ?? [];
    return /*#__PURE__*/ _jsxs("picture", {
        ...props,
        children: [
            !isSvgImage(asset.filename) && generateImageSources(asset?.filename, maxWidth, params),
            /*#__PURE__*/ _jsx("img", {
                alt: asset.alt || description,
                className: classNames(styles.image, isBackground && styles['image-is-background'], isFullWidth && styles['image-is-full-width']),
                fetchPriority: loading === 'eager' ? 'high' : 'auto',
                height: height,
                loading: loading,
                src: isSvgImage(asset.filename) ? asset.filename : buildImageSrcSet(asset.filename, Math.min(maxWidth, 360), params),
                width: width
            })
        ]
    });
};

//# sourceMappingURL=Picture.js.map